import Vue from 'vue';
import Acl from '@/plugins/acl/aclPlugin';

Vue.use(Acl);
